<template>
  <div class="center-cmp-wrapper">
    <div class="center-cmp" id="center-cmp"></div>
    <div class="equipment__count">
      <p>设备总数：{{ equipmentCount.assets_code }}</p>
      <p>设备总金额（元）：{{ equipmentCount.hxcs_htzj }}</p>
      <p>设备总收益（元）：{{ equipmentCount.between_sbsy }}</p>
    </div>
  </div>
</template>

<script>
import { querysbsyfxdt, querysbsyfxdttj } from '@/api/modules/dataView.js'
import '@/data/china'
export default {
  name: 'CenterCmp',
  components: {},
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
      equipmentCount: {
        assets_code: '',
        hxcs_htzj: '',
        between_sbsy: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const mapData = await querysbsyfxdt(this.date)
      querysbsyfxdttj(this.date).then(data => {
        // this.equipmentCount = data
        if (data) {
          this.equipmentCount = data[0]
        }
      })
      var chartDom = document.getElementById('center-cmp')
      this.chart = this.$echarts.init(chartDom)
      let ysdwamountData = []
      let sbamountData = []
      let sbzjeData = []
      let sbzsyData = []
      let maxNum = 0
      for (const item of mapData) {
        ysdwamountData.push({
          name: item.province.replace('市', '').replace('省', ''),
          value: item.count_province || 0,
        })
        sbamountData.push({
          name: item.province.replace('市', '').replace('省', ''),
          value: item.assets_code || 0,
        })
        // ysdwamountData.push({ name: item.addr, value: item.count_province })
        // sbamountData.push({ name: item.addr, value: item.assets_code })
        sbzjeData.push({
          name: item.province.replace('市', '').replace('省', ''),
          value: item.hxcs_sbzje || 0,
        })
        sbzsyData.push({
          name: item.province.replace('市', '').replace('省', ''),
          value: item.between_sbsy || 0,
        })
        if (item.assets_code > maxNum) {
          maxNum = item.assets_code
        }
      }
      var dataList = [
        { name: '南海诸岛', value: 0 },
        { name: '北京', value: randomValue() },
        { name: '天津', value: randomValue() },
        { name: '上海', value: randomValue() },
        { name: '重庆', value: randomValue() },
        { name: '河北', value: randomValue() },
        { name: '河南', value: randomValue() },
        { name: '云南', value: randomValue() },
        { name: '辽宁', value: randomValue() },
        { name: '黑龙江', value: randomValue() },
        { name: '湖南', value: randomValue() },
        { name: '安徽', value: randomValue() },
        { name: '山东', value: randomValue() },
        { name: '新疆', value: randomValue() },
        { name: '江苏', value: randomValue() },
        { name: '浙江', value: randomValue() },
        { name: '江西', value: randomValue() },
        { name: '湖北', value: randomValue() },
        { name: '广西', value: randomValue() },
        { name: '甘肃', value: randomValue() },
        { name: '山西', value: randomValue() },
        { name: '内蒙古', value: randomValue() },
        { name: '陕西', value: randomValue() },
        { name: '吉林', value: randomValue() },
        { name: '福建', value: randomValue() },
        { name: '贵州', value: randomValue() },
        { name: '广东', value: randomValue() },
        { name: '青海', value: randomValue() },
        { name: '西藏', value: randomValue() },
        { name: '四川', value: randomValue() },
        { name: '宁夏', value: randomValue() },
        { name: '海南', value: randomValue() },
        { name: '台湾', value: randomValue() },
        { name: '香港', value: randomValue() },
        { name: '澳门', value: randomValue() },
      ]
      function randomValue() {
        return Math.round(Math.random() * 500)
      }
      let option = {
        tooltip: {
          formatter: function(params) {
            const mySeries = option.series
            let resStr = params.name + '<br />'
            for (let i = 0; i < mySeries.length; i++) {
              for (let k = 0; k < mySeries[i].data.length; k++) {
                if (mySeries[i].data[k].name === params.name) {
                  resStr +=
                    mySeries[i].name +
                    ':' +
                    mySeries[i].data[k].value +
                    '<br />'
                }
              }
            }
            return resStr
          }, // 数据格式化
        },
        visualMap: {
          min: 0,
          max: maxNum,
          left: 'left',
          top: 'bottom',
          text: ['高', '低'], // 取值范围的文字
          inRange: {
            color: ['#e8ffc1', '#9ef5cf', '#65c6c4', '#0278ae', '#015668'], // 取值范围的颜色
            // color: ['lightskyblue','yellow', 'orangered']
          },
          show: false, //图注
        },
        geo: {
          map: 'china',
          roam: false, // 不开启缩放和平移
          zoom: 1.23, // 视角缩放比例
          label: {
            normal: {
              show: true,
              fontSize: '10',
              color: 'rgba(0,0,0,0.7)',
            },
          },
          itemStyle: {
            normal: {
              borderColor: 'rgba(0, 0, 0, 0.2)',
            },
            emphasis: {
              areaColor: '#F3B329', // 鼠标选择区域颜色
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
        series: [
          {
            name: '委预算单位个数',
            type: 'map',
            geoIndex: 0,
            data: ysdwamountData,
          },
          {
            name: '设备总数',
            type: 'map',
            geoIndex: 0,
            data: sbamountData,
          },
          {
            name: '设备总金额（元）',
            type: 'map',
            geoIndex: 0,
            data: sbzjeData,
          },
          {
            name: '设备总收益（元）',
            type: 'map',
            geoIndex: 0,
            data: sbzsyData,
          },
        ],
      }

      option && this.chart.setOption(option)
    },
  },
}
</script>

<style lang="scss" scoped>
.center-cmp-wrapper {
  width: 100%;
  height: 60%;
  position: relative;
}
.center-cmp {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-direction: column;
}
.equipment__count {
  position: absolute;
  left: 10px;
  bottom: 20px;
  font-weight: bold;
  p {
    margin-bottom: 10px;
  }
}
</style>
